export enum DropdownIconNames {
  VALUATION_TABLE = "valuation-table",
  MANAGE_USERS = "manage-users",
  ADMIN = "admin",
  EDIT_PRICING_RULES = "edit-pricing-rules",
  LOG_OUT = "log-out",
}
